import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FormBuilder } from '@angular/forms';
import { ModalPagamentoService } from './modal-pagamento.service';
import { NotificationsService } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';
import { SpringDatatablePaginationService } from '../../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';

import * as QRCode from 'qrcode';

@Component({
  selector: 'ngx-modal-pagamento',
  templateUrl: './modal-pagamento.component.html',
  styleUrls: ['./modal-pagamento.component.scss'],
})
export class ModalPagamentoComponent implements OnInit {

  @Input() paymentData: any;
 
  @ViewChild("card", null)
  private card: ElementRef;
  public tamanho: number = 200;
 
  public customLogin = null;
  public cnpj = null;
  public razaoSocial = null;
  public instituicao = null;
  public codigo = null;
  public isPagtoPix = false;
  public isPagtoBoleto = false;
  public qrcodeUrl = "";
  public isCopied = false;
  public pedidoData = null;

  public paymentDataMock = {
    id: 33,
    valor: 300
  }

  public pedidoDataMock ={
    dadosPix: {
      cnpjEmissor: '33.449.007/0001-44',
      razaoSocialEmissor : 'Empresa Brasileira de Benefícios e Pagamento Ltda',
      instituicao : 'DOCK IP S.A',
      pixCopiaCola : '00020101021126660014br.gov.bcb.pix0136a2eb0360-493e.46b1.ac86-22df16706d7a0204Caju520400005303986540510.005802BR5919EMPRESA-BBE-PAGAM6009SAO-PAULO62290525te07U0NvNiGhx4arGPYipsFbq6304341E'
    }
  }



  constructor(
    protected ref: NbDialogRef<ModalPagamentoComponent>,
    private service: ModalPagamentoService,
    private notificationService: NotificationsService,
    private changeDetector: ChangeDetectorRef,
  ) {
    

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    this.card.nativeElement.ownerDocument.activeElement.blur();
    
    this.buscaDadosPedido(this.paymentData.id);
    this.isPagtoBoleto = this.paymentData.formaPagamento == "BOLETO";
    this.isPagtoPix = this.paymentData.formaPagamento == "PIX";
    
    this.generateQrCode(this.pedidoData.dadosPix.pixCopiaCola)
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }


  gotoVoltar() {

    this.ref.close();

  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  buscaDadosPedido(pedidoId) {

    // this.spinnerService.show();
    this.service.getPedido(pedidoId, ( response => {
      this.pedidoData = response;
      if(this.isPagtoPix){
        this.generateQrCode(this.pedidoData.dadosPix.pixCopiaCola);
      }
      // this.spinnerService.hide();
    }), (error) => {
      // this.spinnerService.hide();
      this.notificationService.error(error.message);
    });
    
  }

  generateQrCode(data: string){
    QRCode.toDataURL(data, (err, url) => {
      if(err){
        console.log("Error generating qrcode: ", err);
        return;
      }
      this.qrcodeUrl = url;
    });
  }


  async generatePDF() {
    
    const codigoPix = this.pedidoData.dadosPix.pixCopiaCola;
    const razaoSocial = this.pedidoData.dadosPix.razaoSocialEmissor;
    const cnpj = this.pedidoData.dadosPix.cnpjEmissor;
    const valor = this.paymentData.valor;

    const qrCodeImage = this.qrcodeUrl;

    this.service.generatePDF(codigoPix, razaoSocial, cnpj, valor, qrCodeImage);
  }


  copy2Clip() {
    const text2Copy = this.isPagtoPix ?  this.pedidoData.dadosPix.pixCopiaCola : this.pedidoData.dadosBoleto.linhaDigitavel ;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text2Copy)
        .then(() => {
          console.log('Texto copiado!')
          this.isCopied = true;
          setTimeout(()=>{this.isCopied = false}, 1000);
        }) 
        .catch(err => console.error('Erro ao copiar texto: ', err));
    } else {
      // Fallback para navegadores que não suportam a API Clipboard
      const textField = document.createElement('textarea');
      textField.innerText = text2Copy ;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy');
      textField.remove();
      this.isCopied = true;
          setTimeout(()=>{this.isCopied = false}, 1000);
    }
  }

  showPdfboleto(pedidoId, boletoB64){
    var pdfResult = boletoB64;
                        
    let pdfWindow = window.open("",pedidoId,"height=1000px, width=1300px");
    pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(pdfResult) + "'></iframe>");
    pdfWindow.document.title = "Pedido "+pedidoId;
  }



}
